import { HTTP } from './helpers/http.js'

export default {
  getById(organizationId, revId) {
    const url = `/api/v1/organizations/${organizationId}/problem-solving/${revId}`
    return HTTP.get(url)
  },

  create(organizationId, data) {
    const url = `/api/v1/organizations/${organizationId}/problem-solving`
    return HTTP.post(url, data)
  },

  update(organizationId, revId, data) {
    const url = `/api/v1/organizations/${organizationId}/problem-solving/${revId}`
    return HTTP.patch(url, data)
  },

  delete(organizationId, revId) {
    const url = `/api/v1/organizations/${organizationId}/problem-solving/${revId}`
    return HTTP.delete(url)
  },

  share(organizationId, payload) {
    const url = `/api/v1/organizations/${organizationId}/shares`
    const { sharedBy, sharedTo, message, sharedObjectId } = payload

    return HTTP.post(url, {
      organizationId,
      sharedBy,
      sharedTo,
      message,
      sharedObjectId,
      sharedObjectType: 'ProblemSolving',
    })
  },

  addValidation({
    organizationId,
    revId,
    validationType,
    isValidated,
    validatedReview,
  }) {
    const url = `/api/v1/organizations/${organizationId}/problem-solving/${revId}/validations`
    return HTTP.post(url, {
      type: validationType,
      isValidated,
      validatedReview,
    })
  },

  editValidation({
    organizationId,
    revId,
    validationType,
    isValidated,
    validatedReview,
    validationId,
  }) {
    const url = `/api/v1/organizations/${organizationId}/problem-solving/${revId}/validations/${validationId}`
    return HTTP.put(url, {
      type: validationType,
      isValidated,
      validatedReview,
    })
  },

  removeValidation({ organizationId, revId, validationId }) {
    const url = `/api/v1/organizations/${organizationId}/problem-solving/${revId}/validations/${validationId}`
    return HTTP.delete(url)
  },

  addHighlight({ organizationId, revId }) {
    return HTTP.post(
      `/api/v1/organizations/${organizationId}/problem-solving/${revId}/highlights`
    )
  },

  removeHighlight({ organizationId, revId }) {
    return HTTP.delete(
      `/api/v1/organizations/${organizationId}/problem-solving/${revId}/highlights`
    )
  },

  savePartialValidation(organizationId, revId, data) {
    const url = `/api/v1/organizations/${organizationId}/problem-solving/${revId}/validation-impacts`
    return HTTP.patch(url, data)
  },

  addImplementValidation({ organizationId, revId }) {
    return HTTP.post(
      `/api/v1/organizations/${organizationId}/problem-solving/${revId}/implementation-validations`
    )
  },

  removeImplementationValidation({ organizationId, revId, validationId }) {
    return HTTP.delete(
      `/api/v1/organizations/${organizationId}/problem-solving/${revId}/implementation-validations/${validationId}`
    )
  },

  addImpactValidation({ organizationId, revId }) {
    return HTTP.post(
      `/api/v1/organizations/${organizationId}/problem-solving/${revId}/impact-validations`
    )
  },

  removeImpactValidation({ organizationId, revId, validationId }) {
    return HTTP.delete(
      `/api/v1/organizations/${organizationId}/problem-solving/${revId}/impact-validations/${validationId}`
    )
  },
}
